import { render, staticRenderFns } from "./T06.vue?vue&type=template&id=1fe9fddc&scoped=true"
import script from "./T06.vue?vue&type=script&lang=js"
export * from "./T06.vue?vue&type=script&lang=js"
import style0 from "./T06.vue?vue&type=style&index=0&id=1fe9fddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe9fddc",
  null
  
)

export default component.exports